export default function Prompts() {
  return (
    <svg fill='none' height='32' viewBox='0 0 32 32' width='32' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.33329 5H25.6666M28.3333 11.6667V23C28.3333 24.4728 27.1394 25.6667 25.6666 25.6667H6.33329C4.86053 25.6667 3.66663 24.4728 3.66663 23V11.6667C3.66663 10.1939 4.86053 9 6.33329 9H25.6666C27.1394 9 28.3333 10.1939 28.3333 11.6667Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  );
}
